__turbopack_context__.v({
  "AgencyReferralSection": "AgencyReferralForm-module-scss-module__KfrZZW__AgencyReferralSection",
  "KeyAndValue": "AgencyReferralForm-module-scss-module__KfrZZW__KeyAndValue",
  "ReferralForm": "AgencyReferralForm-module-scss-module__KfrZZW__ReferralForm",
  "TextImageSection": "AgencyReferralForm-module-scss-module__KfrZZW__TextImageSection",
  "TextSection": "AgencyReferralForm-module-scss-module__KfrZZW__TextSection",
  "TextValue": "AgencyReferralForm-module-scss-module__KfrZZW__TextValue",
  "error": "AgencyReferralForm-module-scss-module__KfrZZW__error",
  "fieldContainer": "AgencyReferralForm-module-scss-module__KfrZZW__fieldContainer",
  "imageSection": "AgencyReferralForm-module-scss-module__KfrZZW__imageSection",
  "splitField": "AgencyReferralForm-module-scss-module__KfrZZW__splitField",
  "success": "AgencyReferralForm-module-scss-module__KfrZZW__success",
});
